/* eslint-disable @typescript-eslint/no-var-requires */
const ICO_BCMC = require("./images/ico_bcmc.png");
const ICO_CIRCLE = require("./images/ico_circle.svg");
const ICO_CLOSE = require("./images/ico_close.svg");
const ICO_CLOSE_ERROR = require("./images/ico_close_error.svg");
const ICO_CLOSE_INFO = require("./images/ico_close_info.svg");
const ICO_CLOSE_ROUND = require("./images/ico_close_round.svg");
const ICO_CLOSE_SUCCESS = require("./images/ico_close_success.svg");
const ICO_CURRENCY_TAG = require("./images/ico_currency_tag.svg");
const ICO_IDEAL = require("./images/ico_ideal.png");
const ICO_IBANISATION = require("./images/ico_ibanisation.png");
const ICO_MAESTRO = require("./images/ico_maestro.png");
const ICO_PHONE = require("./images/ico_phone.svg");
const ICO_PROFILE_ROUND = require("./images/ico_profile_round.svg");
const ICO_QR_PROVIDERS = require("./images/ico_qr_providers@3x.png");
const ICO_SEPA = require("./images/ico_sepa.svg");
const IMG_BACKGROUND_LEFT = require("./images/img_background_left.jpg");
const IMG_BACKGROUND_RIGHT = require("./images/img_background_right.jpg");
const IMG_RENTIO_LOGO = require("./images/img_rentio_logo.png");
const IMG_RENTIO_LOGO_COPYRIGHT = require("./images/img_rentio_logo_copyright.png");

export default {
  ICO_BCMC,
  ICO_CIRCLE,
  ICO_CLOSE_ERROR,
  ICO_CLOSE_INFO,
  ICO_CLOSE_ROUND,
  ICO_CLOSE_SUCCESS,
  ICO_CLOSE,
  ICO_CURRENCY_TAG,
  ICO_IBANISATION,
  ICO_IDEAL,
  ICO_MAESTRO,
  ICO_PHONE,
  ICO_PROFILE_ROUND,
  ICO_QR_PROVIDERS,
  ICO_SEPA,
  IMG_BACKGROUND_LEFT,
  IMG_BACKGROUND_RIGHT,
  IMG_RENTIO_LOGO_COPYRIGHT,
  IMG_RENTIO_LOGO,
};
